module.exports = __webpack_public_path__ + "media/images/favicon-b770f1a055a139e8da2aefbe4c2d6518.ico";